import { createFileRoute, Navigate } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { SettingsNav } from "../settings/settings-nav.tsx";
import { useIsExpanded } from "../shell/device-class.ts";

import type { ReactElement } from "react";

const SettingsIndex = (): ReactElement | null => {
  const viewer = useViewer();
  const isExpanded = useIsExpanded();
  if (isExpanded) {
    return <Navigate to="/settings/$section" params={{ section: "profile" }} replace />;
  }
  return viewer === null ? null : (
    <div className="p-4">
      <SettingsNav viewer={viewer} />
    </div>
  );
};

export const Route = createFileRoute("/_app/settings/")({
  component: SettingsIndex,
});
